(function () {
    "use strict";

    angular
        .module('Services')
        .constant('shipmentStatuses', {
            'new': 'New',
            'unprocessed': 'Unprocessed',
            'inprogress': 'Processing',
            'pending': 'Awaiting Booking',
            'processed': 'Completed'
        });

})();


// WEBPACK FOOTER //
// ./js/consts/shipmentStatusesService.js